<div class="infobox">
  @if (iconName) {
  <div class="icon">
    <firebird-web-icon
      [name]="iconName"
      width="15px"
      height="15px"
    ></firebird-web-icon>
  </div>
  }
  <div>
    <ng-content> </ng-content>
  </div>
  @if (showButton) {
  <div class="cta-btn">
    <firebird-web-button
      [disabled]="false"
      [style]="'quaternary'"
      [labelKey]="labelKey"
    >
    </firebird-web-button>
  </div>
  }
</div>
